export default "__VITE_ASSET__CJR3gmTM__"